import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type ActionWithId = {
  idAction: number;
};

// Типы для WebSocket сообщений компонента actions
type ActionErrorTranslationsMessage = WebSocketMessageWithFields<'language-action-error-translations' | 'language-action-error-list', {
  action: unknown;
}>;
type ActionListMessage = WebSocketMessageWithFields<'language-action-list', {
  actions: unknown[];
}>;
type ActionCreateMessage = WebSocketMessageWithFields<'language-action-create' | 'language-action-create-success', ActionWithId & {
  name: string;
}>;
type ActionDeleteMessage = WebSocketMessageWithFields<'language-action-delete' | 'language-action-delete-success', ActionWithId>;

// Объединенный тип для всех сообщений
type ActionsWebSocketMessage = 
  | ActionErrorTranslationsMessage 
  | ActionListMessage 
  | ActionCreateMessage 
  | ActionDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataActions',
},
  __name: 'actions',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID действия
const handleWebSocketMessage = (data: ActionsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-action-error-translations':
    case 'language-action-error-list':
      store.dispatch('action/wsSetAction', data.action);
      break;

    case 'language-action-list':
      store.dispatch('actions/wsSetActions', { actions: data.actions });
      break;

    case 'language-action-create':
    case 'language-action-create-success':
      store.dispatch('actions/wsActionCreate', {
        idAction: data.idAction,
        name: data.name,
      });
      break;

    case 'language-action-delete':
    case 'language-action-delete-success':
      store.dispatch('actions/wsActionDelete', { idAction: data.idAction });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})